// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sC","itemWrapper":"sD rE","itemStyle":"sE rF"};